// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__m8wnn","header":"About_header__VFn1C","goBack":"About_goBack__ucRvx","container":"About_container__slwJJ"};